var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrophy01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#EAECF5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_34138_211061)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.0002 18.0002C13.791 18.0002 12.0002 16.2093 12.0002 14.0002V10.2965C12.0002 10.0206 12.0002 9.88261 12.0404 9.77215C12.1078 9.58697 12.2536 9.4411 12.4388 9.3737C12.5493 9.3335 12.6872 9.3335 12.9631 9.3335H19.0372C19.3131 9.3335 19.451 9.3335 19.5615 9.3737C19.7467 9.4411 19.8926 9.58697 19.96 9.77215C20.0002 9.88261 20.0002 10.0206 20.0002 10.2965V14.0002C20.0002 16.2093 18.2093 18.0002 16.0002 18.0002ZM16.0002 18.0002V20.0002M20.0002 10.6668H21.6668C21.9775 10.6668 22.1328 10.6668 22.2553 10.7176C22.4186 10.7852 22.5484 10.915 22.6161 11.0784C22.6668 11.2009 22.6668 11.3562 22.6668 11.6668V12.0002C22.6668 12.6201 22.6668 12.9301 22.5987 13.1845C22.4137 13.8747 21.8747 14.4137 21.1845 14.5987C20.9301 14.6668 20.6201 14.6668 20.0002 14.6668M12.0002 10.6668H10.3335C10.0229 10.6668 9.86755 10.6668 9.74504 10.7176C9.58169 10.7852 9.45191 10.915 9.38424 11.0784C9.3335 11.2009 9.3335 11.3562 9.3335 11.6668V12.0002C9.3335 12.6201 9.3335 12.9301 9.40164 13.1845C9.58658 13.8747 10.1257 14.4137 10.8159 14.5987C11.0702 14.6668 11.3802 14.6668 12.0002 14.6668M12.9631 22.6668H19.0372C19.2008 22.6668 19.3335 22.5342 19.3335 22.3705C19.3335 21.0614 18.2722 20.0002 16.9631 20.0002H15.0372C13.7281 20.0002 12.6668 21.0614 12.6668 22.3705C12.6668 22.5342 12.7995 22.6668 12.9631 22.6668Z",
    stroke: "#3E4784",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_34138_211061"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(8 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrophy01);
export default __webpack_public_path__ + "static/media/trophy-01.07e1ae326283993fc04f18796bfd018f.svg";
export { ForwardRef as ReactComponent };